import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";

import { restoreSession } from "@/features/auth/session/restore";
import { completeSsoCallback } from "@/features/auth/session/sso-callback";
import { AppProviders } from "@/providers/app-providers";
import { router } from "@/routes";

import "@/lib/api-client";
import "./index.css";

async function startAuth() {
  if (!(await completeSsoCallback())) {
    await restoreSession();
  }
}

void startAuth();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
